import * as React from 'react';
import { makeAlarmsListGroupComponent } from './AlarmListGroup';

type Props<TValue, TOptions> = {
    groups: Array<{
        name: string;
        id?: string;
        channelCount?: number;
        items?: TValue[];

    }>;
    component: React.FunctionComponent<{
        testId?: string;
        value: TValue;
        isLast: boolean;
        options?: TOptions;
        onClick?: () => void;
    }>;
    componentTestId?: string;
    options?: TOptions;
    navigationFn?: (arg: TValue) => void;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function makeAlarmsListGroupsComponent<TValue, TOptions = never>() {
    const ListGroupComponent = makeAlarmsListGroupComponent<TValue, TOptions>();

    const component: React.FC<Props<TValue, TOptions>> = (props) => {
        const ListItemComponent = props.component;

        return (
            <div>
                {props.groups.map((group, groupIndex) => (
                    <ListGroupComponent
                        key={groupIndex}
                        group={group}
                        component={ListItemComponent}
                        options={props.options}
                        componentTestId={props.componentTestId}
                        style={{ marginTop: groupIndex > 0 ? '1px' : undefined }}
                        navigationFn={props.navigationFn}
                    />
                ))}
            </div>
        );
    };

    return component;
}
